import React from "react";
import AddProductoForm from "./AddProductoForm";

const AddProducto = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Producto"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddProductoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddProducto;
